

export let CollectionTags = [
    {
        "type": "collection",
        "_id": "62ab16ac56928a0016be5931",
        "tag": "mild",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac02952631c1001682eb23",
        "tag": "gold",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac02992631c1001682eb24",
        "tag": "dark",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac02a22631c1001682eb25",
        "tag": "pastel",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac02a92631c1001682eb26",
        "tag": "neon",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac02af2631c1001682eb27",
        "tag": "skin",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac02b52631c1001682eb28",
        "tag": "rainbow",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac02bc2631c1001682eb29",
        "tag": "retro",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac02c32631c1001682eb2a",
        "tag": "vintage",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac02c82631c1001682eb2b",
        "tag": "food",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac02cc2631c1001682eb2c",
        "tag": "summer",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac02d22631c1001682eb2d",
        "tag": "light",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac02da2631c1001682eb2e",
        "tag": "cream",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac02df2631c1001682eb2f",
        "tag": "earth",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac02e72631c1001682eb30",
        "tag": "coffie",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac02f92631c1001682eb31",
        "tag": "nature",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac03002631c1001682eb32",
        "tag": "warm",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac03062631c1001682eb33",
        "tag": "spring",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac030d2631c1001682eb34",
        "tag": "night",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac03112631c1001682eb35",
        "tag": "space",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac03162631c1001682eb36",
        "tag": "winter",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac03212631c1001682eb37",
        "tag": "sunset",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac032e2631c1001682eb38",
        "tag": "chirstmas",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac03332631c1001682eb39",
        "tag": "kids",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac03392631c1001682eb3a",
        "tag": "happy",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac03402631c1001682eb3b",
        "tag": "cold",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac03472631c1001682eb3c",
        "tag": "fail",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac034d2631c1001682eb3d",
        "tag": "wedding",
        "__v": 0
    },
    {
        "type": "collection",
        "_id": "62ac03572631c1001682eb3e",
        "tag": "halloween",
        "__v": 0
    }
]